/**
 * Định nghĩa DUY NHẤT của "màn điện thoại" cho bố cục trình xem.
 *
 * Hai vế: màn dọc hẹp dưới 768px (mốc md của Tailwind), hoặc màn cảm ứng thấp dưới 500px — điện thoại
 * xoay ngang rộng 800–900px nhưng chỉ cao ~390px, trước đây bị coi là desktop nên panel trái mở sẵn
 * 282px và ảnh còn một nửa. Vế sau đòi pointer:coarse để cửa sổ desktop bị kéo thấp không dính.
 *
 * CSS không import được hằng này: CustomizableViewportOverlay.css (extension cornerstone) chép lại
 * nguyên chuỗi, sửa ở đây thì sửa cả ở đó.
 */
export const TRUY_VAN_MAN_HINH_HEP = '(max-width: 767px), (max-height: 500px) and (pointer: coarse)';

export function laManHinhHep(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(TRUY_VAN_MAN_HINH_HEP).matches;
}

/**
 * Gọi `cb` ngay với trạng thái hiện tại rồi mỗi lần trạng thái đổi (xoay máy, kéo cửa sổ). Gọi ngay là để không lỡ lần
 * đổi xảy ra giữa lúc render (đọc laManHinhHep) và lúc effect đăng ký. Trả về hàm huỷ theo dõi.
 */
export function theoDoiManHinhHep(cb: (hep: boolean) => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const mq = window.matchMedia(TRUY_VAN_MAN_HINH_HEP);
  const doi = (e: MediaQueryListEvent) => cb(e.matches);

  mq.addEventListener('change', doi);
  cb(mq.matches);
  return () => mq.removeEventListener('change', doi);
}
